/**
 * The stored form's layout: field name to the short code it is stored as.
 *
 * The single statement of that mapping, and pure data by design. Binding it to
 * a store is the caller's job; this table is the part that was worth not
 * duplicating.
 *
 * A second copy of this mapping lives outside this codebase, because the same
 * form is also written server-side. The two cannot be merged while that
 * remains true, and nothing compares them — which is how `editorial_film` once
 * went missing from the browser's copy. The only defence is that each side
 * states the whole set in one place.
 */
export const SEARCH_PREFERENCE_FIELD_CODES = {
  search_details: 'sd',
  refinement_panel_state: 'rps',
  editorial_sort: 'es',
  editorial_archival_sort: 'eas',
  editorial_event_sort: 'evs',
  search_grid_layout: 'sgl',
  image_search_grid_layout: 'isgl',
  film_search_grid_layout: 'fsgl',
  saved_filters: 'sf',
  pa_agreement: 'pa',
  hide_creative_banner: 'hcb',
  hide_prestige_banner: 'hpb',
  hide_adobe_plugin_banner: 'hapb',
  hide_single_seat_subscription_banner: 'hssb',
  creative_image: 'ci',
  editorial_image: 'ei',
  mixed_image: 'mi',
  creative_film: 'cf',
  editorial_film: 'ef',
  mixed_film: 'mf',
  analog_film: 'af',
  creative_image_film: 'cif',
  group_by_event: 'gbe',
  gateway_srp: 'gsrp',
  suppress_enhanced_phrase_correction: 'sepc',
} as const;

/** Every field name the stored form declares. Derived, so it cannot drift from the map. */
export type SearchPreferenceFieldName =
  keyof typeof SEARCH_PREFERENCE_FIELD_CODES;

export const SEARCH_PREFERENCE_FIELD_NAMES = Object.keys(
  SEARCH_PREFERENCE_FIELD_CODES
) as SearchPreferenceFieldName[];
